import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import PracticeAreas from "@/components/landing/PracticeAreas";
import Experience from "@/components/landing/Experience";
import Semblanza from "@/components/landing/Semblanza";
import PortalSection from "@/components/landing/PortalSection";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import { BrandProvider } from "@/brand";
import BrandSwitcher from "@/brand/BrandSwitcher";

function App() {
  return (
    <BrandProvider>
      <div className="App bg-[var(--gm-paper)] text-[var(--gm-ink)]">
        <Toaster position="top-center" richColors />
        <Navbar />
        <main>
          <HeroSection />
          <PracticeAreas />
          <Experience />
          <Semblanza />
          <PortalSection />
          <ContactSection />
        </main>
        <Footer />
        <BrandSwitcher />
      </div>
    </BrandProvider>
  );
}

export default App;
